<template>
  <div>
    <div class="p-5" style="background-color: #ebebeb">
      <vxe-toolbar class="mb-4 p-3">
        <template #buttons>
          <button
            @click="print"
            class="px-5 py-2 bg-blue-500 text-white text-sm rounded-md hover:bg-blue-200"
          >
            PRINT NOW
          </button>
        </template>
      </vxe-toolbar>
      <div
        id="printMe"
        class="bg-white border p-3 rounded"
        style="background-color: white"
      >
        <div
          class="container"
          contenteditable
          style="color: black; width: 100%"
        >
          <div class="flex flex-row items-center space-x-5">
            <img src="logos/greentex.png" style="width: 30mm" />
            <div class="flex flex-col justify-start">
              <h1 class="font-bold text-base">
                {{ $store.state.companyName }}
              </h1>
              <p
                v-html="company.alamat"
                class="text-xs mr-5"
                style="width: 90%; color: black"
              ></p>
            </div>
          </div>
          <div>
            <div
              class="border-4 border-black w-full h-1 rounded-t-full mb-2"
            ></div>
            <!-- TABLE HEADE -->
            <table class="w-full text-black table-fixed" style="width: 100%">
              <thead>
                <tr>
                  <th class="border-l-2 border-t-2 border-black">
                    <p class="mt-6 text-xl font-extrabold text-center">
                      PURCHASE ORDER
                    </p>
                  </th>
                  <th class="border-2 border-black text-sm" style="width: 30mm">
                    In Charge
                  </th>
                  <th class="border-2 border-black text-sm" style="width: 30mm">
                    Manager
                  </th>
                  <th class="border-2 border-black text-sm" style="width: 30mm">
                    Pres dir
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr class="text-sm">
                  <!-- NO PO VALUE -->
                  <td
                    style="height: 20mm; color: black"
                    class="border-l-2 border-b-2 border-black text-sm text-center"
                  >
                    NO PO: {{ data.noPo }}
                  </td>
                  <td class="border-2 border-black"></td>
                  <td class="border-2 border-black"></td>
                  <td class="border-2 border-black"></td>
                </tr>
                <tr class="text-sm p-2">
                  <td class="border-l-2 border-r-2 border-black pl-2">
                    To :

                    <b>{{ data.namaSupplier }}</b>

                    <p class="text-xs">
                      {{ data.alamatSupplier }}
                    </p>
                  </td>
                  <td class="border-b-2 border-l-2 border-black p-1">
                    Fak No:
                  </td>
                  <!-- Fak No Valuw -->
                  <td class="border-b-2 border-black"></td>
                  <td class="border-b-2 border-r-2 border-black"></td>
                </tr>
                <tr class="text-sm p-2">
                  <td class="border-b-2 border-l-2 border-r-2 border-black">
                    <!-- TO: VALUE -->
                    <p class="font-bold pl-2"></p>
                    <p class="pl-2 pb-2"></p>
                  </td>
                  <td class="border-b-2 border-black pl-2">Delivery:</td>
                  <!-- Delivery Value -->
                  <td class="border-b-2 border-black"></td>
                  <td class="border-b-2 border-black border-r-2"></td>
                </tr>
                <tr class="border-r-2 border-l-2 border-black text-sm">
                  <td>
                    <div class="flex flex-row space-x-2 p-2">
                      <p>Attn:</p>
                    </div>
                  </td>
                  <td class="border-l-2 border-black pl-2">Payment:</td>
                  <!-- Payment Value -->
                  <td class="border-black py-2">{{ data.payterm }}</td>
                </tr>
              </tbody>
            </table>
            <!-- TABLE ITEMS LIST -->
            <table class="w-full table-fixed">
              <thead>
                <tr>
                  <th
                    class="border-2 border-black text-center"
                    style="width: 15mm"
                  >
                    Item
                  </th>
                  <th class="border-2 border-black">Description</th>
                  <th class="border-2 border-black" style="width: 25mm">
                    Quantity
                  </th>
                  <th class="border-2 border-black" style="width: 37mm">
                    Unit Price
                  </th>
                  <th class="border-2 border-black" style="width: 35mm">
                    Amount
                  </th>
                </tr>
              </thead>
              <tbody>
                <!-- LOOP DATA -->
                <tr
                  style="color: black !important"
                  class="text-center text-sm font-semibold border-2 border-black"
                  v-for="(d, i) in dataTable"
                  :key="i"
                >
                  <td class="border-2 border-black" style="width: 15mm">
                    {{ i + 1 }}
                  </td>
                  <td class="text-left p-1 border-2 border-black">
                    {{
                      d.namaBarang +
                      " " +
                      (d.size || "") +
                      " " +
                      (d.color || "")
                    }}
                  </td>
                  <td class="text-left p-1 border-2 border-black">
                    <div class="w-full flex flex-row justify-between">
                      <p>{{ $formatAngka(d.qty) }}</p>
                      <p>{{ d.satuan ? d.satuan.toUpperCase() : "" }}</p>
                    </div>
                  </td>
                  <td class="p-1 border-2 border-black text-right">
                    {{ $formatAmountBc(d.price) }}
                  </td>
                  <td class="text-left p-1 border-2 border-black">
                    <div class="w-full flex flex-row justify-between">
                      <p>{{ data.currency }}</p>
                      <p>{{ $formatAmountBc(d.qty * d.price) }}</p>
                    </div>
                  </td>
                </tr>
                <!-- Keterangan Table -->
                <tr class="h-5 border-r-2 border-l-2 border-black">
                  <td></td>
                  <td></td>
                  <td></td>
                  <td class="p-2 font-bold border-2 border-black">TOTAL:</td>
                  <td class="p-2 font-bold border-2 border-black text-right">
                    {{ $formatAmountBc(data.jumlahAmount) }}
                  </td>
                </tr>
                <tr class="border-l-2 border-black">
                  <td></td>
                  <td>
                    <p class="font-bold text-lg">Keterangan:</p>
                    {{ data.remark }}
                  </td>
                  <td></td>
                  <td
                    class="border-r-2 border-l-2 border-b-2 border-black p-2 font-bold"
                  ></td>
                  <td
                    class="border-r-2 border-l-2 border-b-2 border-black p-2 font-bold"
                  ></td>
                  <!-- <td
                    v-if="dataPajak.length > 0"
                    class="border-r-2 border-l-2 border-b-2 border-black p-2 font-bold"
                    v-for="d in dataPajak"
                    :key="d.value"
                  >
                    <p v-if="d && d.value != 'no'">
                      {{ d && d.value != "no" ? d.jenisTransaksi : "" }}
                    </p>
                  </td>
                  <td
                    v-if="dataPajak.length > 0"
                    class="border-r-2 border-l-2 border-b-2 border-black p-2 font-bold text-right"
                    v-for="d in dataPajak"
                    :key="d.value"
                  >
                    <p v-if="d && d.value != 'no'">
                      {{ $formatAmountBc(d.totalPjk) }}
                    </p>
                  </td> -->
                </tr>
                <tr
                  class="border-l-2 border-r-2 border-black"
                  v-if="dataPajak.length > 0"
                  v-for="d in dataPajak"
                  :key="d.value"
                >
                  <td></td>
                  <td></td>
                  <td></td>
                  <td class="p-2 font-bold border-2 border-black">
                    {{ d.jenisTransaksi }}:
                  </td>
                  <td class="p-2 font-bold border-2 border-black text-right">
                    {{ $formatAmountBc(d.totalPjk) }}
                  </td>
                </tr>
                <tr class="border-l-2 border-r-2 border-b-2 border-black">
                  <td></td>
                  <td></td>
                  <td></td>
                  <td class="p-2 font-bold border-2 border-black">
                    GRAND TOTAL:
                  </td>
                  <td class="p-2 font-bold border-2 border-black text-right">
                    {{ $formatAmountBc(data.totalAll) }}
                  </td>
                </tr>
              </tbody>
            </table>
            <div class="flex flex-row justify-between mt-5 text-black">
              <div class="flex flex-col space-y-1">
                <p class="font-bold">Syarat :</p>
                <ul
                  class="list-outside list-decimal m-5"
                  style="width: 80%; font-size: 12px"
                >
                  <li>
                    Cantumkan nomor di P O didalam surat jalan dan Invoice:
                  </li>
                  <li>
                    Jika jumlah dan mutu barang tidak sesuai dengan permintaan,
                    maka barang - barang tsb akan dikembalikan dengan biaya yang
                    menjadi beban penjual
                  </li>
                  <li>
                    Dengan pembayaran Tunai / Kredit, ................Hari.
                  </li>
                </ul>
              </div>
              <div class="flex flex-col text-center">
                <p>Bandung {{ formatDate(data.tanggalPo) }}</p>
                <div style="height: 20mm; width: 50mm"></div>
                <p>Purchase Order Dept</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import moment from "moment";
export default {
  props: ["params"],
  components: {},
  data() {
    return {
      dataPajak: [],
      dataJenis: [
        { label: "PPn 11%", value: "ppn11%", nilai: 11 },
        { label: "PPh 2%", value: "pph2%", nilai: 2 },
        { label: "Tidak Kena Pajak", value: "no", nilai: 0 },
      ],
      pajak: { value: "no" },
      numberRowDelete: 1,
      data: { nomorInovoice: "001/123/12312", alamatCompany: "" },
      company: {
        alamat: "",
        fax: "",
        telp: "",
      },
      dataTable: [
        {
          namaBarang: "",
          namaColorSurf: "",
          kodeColorSurf: "",
          tebal: "",
          satuan: "",
          qtyOrder: "",
          price: "",
          noPo: "",
          noShipping: "",
        },
      ],
      optionPemasok: [],
      penerima: {},
    };
  },
  watch: {},
  computed: {},
  methods: {
    formatDate(row) {
      return moment(row).format("DD MMMM YYYY");
    },
    async getData(noPo) {
      let get = await this.$api.get(
        "api/v1/purchasing/podetail/spesific/searchpo",
        {
          params: { noPo: noPo },
        }
      );
      if (!get.data.content) {
        this.$router.push("/purchasing/po");
        return;
      }
      this.id = get.data.content;
      if (this.id) {
        this.dataTable = [];
        this.data = this.id;
        this.data.alamatCompany = "";
        this.data.faxCompany = "";
        this.data.telpCompany = "";
        this.data.tanggalPo = moment(this.id.tanggal).format("YYYY/MM/DD");
        if (this.data.keterangan) {
          this.data.keterangan = this.data.keterangan.replaceAll("\n", "<br>");
        }

        if (!this.data.currency) {
          this.data.currency = "USD";
        }
        this.dataTable = this.id.listDetail;
        if (this.dataTable.length > 0) {
          let jenisTransaksiValue = this.id.jenisTransaksiValue
            ? this.id.jenisTransaksiValue.split(",")
            : [];
          let pajakF = this.dataJenis.filter((f) =>
            jenisTransaksiValue.includes(f.value)
          );

          pajakF.forEach((elPjk) => {
            let totalPjk = 0;
            if (elPjk && elPjk.value != "no") {
              this.dataTable.forEach((elm) => {
                if (!elm.priceTax) elm.priceTax = 0;
                let disc = elm.diskon
                  ? (parseFloat(elm.diskon) / 100) *
                    (parseFloat(elm.price) * parseFloat(elm.qty))
                  : 0;
                console.log(disc, "disc");
                elm.disc = disc;
                elm.priceTax +=
                  (parseFloat(elm.price) * parseFloat(elm.qty) -
                    parseFloat(disc)) *
                  (elPjk.nilai / 100);
                totalPjk +=
                  (parseFloat(elm.price) * parseFloat(elm.qty) -
                    parseFloat(disc)) *
                  (elPjk.nilai / 100);
              });
              this.dataPajak.push({
                totalPjk,
                jenisTransaksi: elPjk.label,
                jenisTransaksiValue: elPjk.value,
                jenisTransaksiNilai: elPjk.nilai,
              });
            }
          });
          console.log(this.dataPajak);
          this.data.jumlahPajak = this.dataTable.reduce((acc, cur) => {
            if (!cur.priceTax) cur.priceTax = 0;

            return acc + Number(cur.priceTax);
          }, 0);

          this.data.jumlahQty = this.dataTable.reduce(
            (acc, cur) => acc + Number(cur.qty),
            0
          );

          this.data.jumlahHarga = this.dataTable.reduce(
            (acc, cur) => acc + Number(cur.price),
            0
          );
          this.data.jumlahAmount = this.dataTable.reduce((acc, cur) => {
            if (!cur.disc) cur.disc = 0;
            return (
              acc +
              Number(parseFloat(cur.price) * parseFloat(cur.qty)) -
              parseFloat(cur.disc)
            );
          }, 0);
          console.log(this.data.jumlahAmount);

          this.data.totalAll = this.data.jumlahAmount + this.data.jumlahPajak;
        }
        let pemasok = this.optionPemasok.find(
          (f) => f.kodeSupplier == this.id.kodeSupplier
        );

        if (pemasok) {
          this.data.namaSupplier = pemasok.namaSupplier;
          this.data.alamatSupplier = pemasok.alamat;
          if (this.data.alamatSupplier) {
            this.data.alamatSupplier = pemasok.alamat.replaceAll("\n", "<br>");
          }

          this.data.namaKontak = pemasok.namaKontak;
          this.data.noTelfon = pemasok.noTelfon;
          this.data.email = pemasok.email;
        }
      }
    },
    async getPemasok() {
      let response = await this.$api.get("/api/v1/masterdata/supplier");

      response.data.forEach((key) => {
        this.optionPemasok.push(key);
      });
    },
    async getCompany() {
      let get = await this.$api.get("api/v1/company/getbycode", {
        params: {
          companyCode: this.$store.state.companyCode,
        },
      });

      this.company.alamat = get.data.content.companyAdress;

      this.company.telp = get.data.content.companyContact;
      this.company.fax = get.data.content.companyFax;
    },

    async print() {
      // Pass the element id here
      await this.$htmlToPaper("printMe", {
        styles: ["https://unpkg.com/tailwindcss@^1.0/dist/tailwind.min.css"],
      });
    },
  },

  async mounted() {
    await this.getPemasok();
    console.log("MASUK PO GREENTEX");
    if (this.params) {
      try {
        this.getData(atob(this.params));
      } catch (error) {
        this.$router.push("/purchasing/po");
      }
      // this.$refs.formPo.setValueForm(this.id);
    } else {
      this.$router.push("/purchasing/po");
    }

    setTimeout(async () => {
      await this.getCompany();
    }, 2000);
  },
};
</script>

<style scoped src="./../../../../../public/css/tailwind1.css"></style>
<!-- <style scoped src="./../../../../public/css/style/quotation.css"></style>   -->
